import { useTranslation } from "react-i18next";
import style from "../../sass/pages/auth/auth-page.module.scss";
import { pushAlert } from "../alerts/alertSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    confirmResetPasswordThunk,
    selectConfirmResetPasswordError,
    selectConfirmResetPasswordStatus,
    setAuthenticated,
} from "./authSlice";
import { useEffect, useState } from "react";
import { setPathToAuthentication } from "../path/pathSlice";
import { validatePassword } from "../registration/validates";

const ConfirmResetPassword = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const error = useSelector(selectConfirmResetPasswordError);
    const status = useSelector(selectConfirmResetPasswordStatus);

    const urlParams = new URLSearchParams(window.location.search);

    const [password, setPassword] = useState("");

    const handleButtonClick = async () => {
        let passwordErr = validatePassword(password);
        let errors = [];

        if (passwordErr) {
            errors.push(passwordErr);
        }

        if (errors.length > 0) {
            errors.forEach((err) => {
                dispatch(
                    pushAlert({
                        type: "danger",
                        message: t(err),
                        delay: 2000,
                    })
                );
            });
            return;
        }

        dispatch(
            confirmResetPasswordThunk({
                password,
                token: urlParams.get("uid"),
            })
        );
    };

    useEffect(() => {
        if (!error) {
            return;
        }
        dispatch(
            pushAlert({
                message: t(error),
                delay: 1000,
                type: "danger",
            })
        );
    }, [dispatch, error, t]);

    const redirectToAuthentication = () => {
        dispatch(setAuthenticated(false));
        dispatch(setPathToAuthentication());
    };

    return (
        <div className={style.container}>
            <main className={style.main}>
                <div className={style.imageBlock}>
                    <img src="/static/images/png/profile-image.png" alt="" />
                </div>

                {status !== "fulfilled" && (
                    <div className={style.rightBlock}>
                        <span className={style.headline}>
                            {t("confirm_reset_password.header")}
                        </span>

                        <div className={style.inputBlock}>
                            <label className={style.inputLabel}>
                                <div className={style.inputSvgBlock}>
                                    <img
                                        src="/static/images/svg/key.svg"
                                        alt=""
                                    />
                                </div>
                                {/* <img src="/static/images/svg/email.svg" alt="" /> */}
                                <input
                                    className={style.input}
                                    type="password"
                                    value={password}
                                    placeholder={t(
                                        "confirm_reset_password.password_placeholder"
                                    )}
                                    onInput={(e) => setPassword(e.target.value)}
                                />
                            </label>
                        </div>

                        <button
                            className={style.button}
                            onClick={handleButtonClick}
                        >
                            {t("confirm_reset_password.confirm_button")}
                        </button>

                        <Link
                            onClick={redirectToAuthentication}
                            className="mt-4 text-2xs text-gray-600 cursor-pointer"
                        >
                            {t("confirm_reset_password.authentication_link")}
                        </Link>
                    </div>
                )}
                {status === "fulfilled" && (
                    <div className={style.rightBlock}>
                        <span className="text-emerald-600">
                            {t("confirm_reset_password.success_message")}
                        </span>

                        <Link
                            onClick={redirectToAuthentication}
                            className="mt-4 text-2xs text-gray-600 cursor-pointer"
                        >
                            {t("confirm_reset_password.authentication_link")}
                        </Link>
                    </div>
                )}
            </main>
        </div>
    );
};

export default ConfirmResetPassword;
